import { useTranslation } from "react-i18next";

const prepItems = [
  "contact.prep.item1",
  "contact.prep.item2",
  "contact.prep.item3",
  "contact.prep.item4",
  "contact.prep.item5",
  "contact.prep.item6",
  "contact.prep.item7",
  "contact.prep.item8",
];

export default function PrepSection() {
  const { t } = useTranslation();

  return (
    <section className="py-14 md:py-20 bg-cream">
      <div className="container-main px-4 md:px-8 lg:px-12">
        <div className="text-center mb-10 md:mb-14">
          <span className="tag-label mb-3 inline-block">{t("contact.prep.label")}</span>
          <h2 className="mb-3">{t("contact.prep.title")}</h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5 max-w-5xl mx-auto">
          {prepItems.map((item, index) => (
            <div
              key={item}
              className="flex items-start gap-3 bg-white rounded-xl p-4 md:p-5 border border-warm-gray/30"
            >
              <span className="w-7 h-7 flex items-center justify-center rounded-full bg-champagne/10 text-champagne text-base font-bold shrink-0">
                {String(index + 1).padStart(2, "0")}
              </span>
              <p className="text-graphite text-base md:text-base font-medium leading-snug pt-0.5">
                {t(item)}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}